import styled from 'styled-components';

const isDefined = val => {
    return val !== 'undefined';
};

const PositionedDiv = styled.div`
    ${ props => {
        const { top, left, mobileTop, mobileLeft, width, mobileWidth } = props;
        let style = '';

        if (width && mobileWidth) {
            style += `
                width: ${ mobileWidth };

                @media (min-width: 768px) {
                    width: ${ width };
                }
            `;
        } else if (width) {
            style += `
                width: ${ width }; 
            `;
        }

        if (mobileTop && mobileLeft) {
            style += `
                top: ${ mobileTop };
                left: ${ mobileLeft };

                @media (min-width: 768px) {
                    top: ${ top };
                    left: ${ left };            
                }
            `;
        } else {
            style += `
                top: ${ top };
                left: ${ left };
            `;
        }

        return style;
    }
}`;

export default PositionedDiv;
